import React from 'react';
import ServicesHeroImg from '../assets/services.png';

const Services = () => {
  return (
    <>
      {/* Banner */}
      <section className="banner">
        <img id="banner-img" src={ServicesHeroImg} alt="services header" />
      </section>

      <main>
        {/* Areas of Specialization */}
        <section className="py-5">
          <div className="container text-center">
            <h3 className="mb-4">Areas of Specialization</h3>

            {/* Highlighted Specialty */}
            {/* <div className="mb-5">
              <span className="d-inline-block px-4 py-2 rounded-pill bg-primary bg-opacity-25 text-primary fw-bold fs-5">
                Orofacial Myofunctional Therapy
              </span>
            </div> */}

            {/* Two-Column Grid */}
            <ul className="list-unstyled row row-cols-1 row-cols-md-2 row-cols-lg-2 g-3 justify-content-center">
              {[
                'Orofacial Myofunctional Therapy',
                'Accent Modification',
                'Sociopragmatic',
                'Apraxia',
                'Articulation',
                'Fluency',
                'Voice',
                'AAC',
                'Language & Literacy',
                'Feeding & Swallowing',
              ].map((item, index) => (
                <li key={index} className="col">
                  <span className="fw-bold fs-5 text-primary">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        {/* Speech & Language Services */}
        <section id="services">
          <div className="container">
            <h2 className="mb-4">Speech &amp; Language Services</h2>
            <p className="mx-auto mb-5" style={{ maxWidth: 700 }}>
              Speech Innovation NC, PLLC, provides personalized, evidence-based treatment services that empower individuals to reach their full potential and promote independence in their community. 
            </p>

            <div className="row g-4">
              <div className="col-md-4">
                <div className="service-card p-4 h-100 shadow-sm rounded bg-white">
                  <h5>Articulation &amp; Speech Clarity</h5>
                  <p>
                    Support for clear pronunciation and sound production, tailored to each client’s needs and goals.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-card p-4 h-100 shadow-sm rounded bg-white">
                  <h5>Language Development</h5>
                  <p>
                    Therapy for expressive and receptive language, helping clients build vocabulary, grammar, and comprehension.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-card p-4 h-100 shadow-sm rounded bg-white">
                  <h5>Fluency &amp; Stuttering</h5>
                  <p>
                    Strategies and support for smoother, more confident speech in everyday communication.
                  </p>
                </div>
              </div>
            </div>

            <div className="row g-4 mt-4">
              <div className="col-md-4">
                <div className="service-card p-4 h-100 shadow-sm rounded bg-white">
                  <h5>Social Communication</h5>
                  <p>
                    Guidance for navigating conversations, interpreting cues, and building meaningful interactions.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-card p-4 h-100 shadow-sm rounded bg-white">
                  <h5>Voice Therapy</h5>
                  <p>
                    Personalized care for vocal tone, pitch, and strength—ideal for vocal fatigue or hoarseness.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="service-card p-4 h-100 shadow-sm rounded bg-white">
                  <h5>Parent &amp; Caregiver Coaching</h5>
                  <p>
                    Collaborative sessions to support carryover at home and empower families in the therapy process.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Services;
